var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolyChart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.05393C18 9.31914 18.1053 9.5735 18.2929 9.76103C18.4804 9.94857 18.7348 10.0539 19 10.0539C19.2652 10.0539 19.5196 9.94857 19.7071 9.76103C19.8946 9.5735 20 9.31914 20 9.05393V1.05393C20 0.78871 19.8946 0.534355 19.7071 0.346819C19.5196 0.159283 19.2652 0.0539265 19 0.0539265H11C10.7348 0.0539265 10.4804 0.159283 10.2929 0.346819C10.1053 0.534355 9.99999 0.78871 9.99999 1.05393C9.99999 1.31914 10.1053 1.5735 10.2929 1.76103C10.4804 1.94857 10.7348 2.05393 11 2.05393H16.59L11 7.64393L7.69999 4.34393C7.51306 4.1607 7.26174 4.05807 6.99999 4.05807C6.73824 4.05807 6.48692 4.1607 6.29999 4.34393L0.29999 10.3439C0.134712 10.5341 0.0472826 10.7795 0.0551794 11.0313C0.0630761 11.2831 0.165718 11.5227 0.342584 11.7021C0.519451 11.8815 0.757509 11.9875 1.00917 11.999C1.26083 12.0104 1.50754 11.9265 1.69999 11.7639L6.99999 6.45393L10.3 9.75393C10.4869 9.93715 10.7382 10.0398 11 10.0398C11.2617 10.0398 11.5131 9.93715 11.7 9.75393L18 3.45393V9.05393Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyChart1);
export default __webpack_public_path__ + "static/media/poly_chart_1.373cdffe10e5c922da8549ed1a6c31f7.svg";
export { ForwardRef as ReactComponent };